module.exports = __webpack_public_path__ + "img/banner4_tv.8e12450f.png";